import { Suspense, useEffect, useMemo } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/theme.css'
import { detectAuth0Screen, resolveScreen, screenTitle } from '@/utils/screenLoader'
import { getPreviewScreen } from '@/utils/helpers'

/**
 * No Custom Domain Auth0 (acesso-b2c-dev.siteteste.inf.br) o HTML é do Universal Login.
 * O bundle ACUL é injetado via head_tags — garantimos um #root para montar a UI Alelo.
 */
function ensureRootElement(): HTMLElement {
  let root = document.getElementById('root')
  if (!root) {
    root = document.createElement('div')
    root.id = 'root'
    document.body.prepend(root)
  }
  return root
}

function App() {
  const screenName = useMemo(
    () => detectAuth0Screen() ?? getPreviewScreen(),
    [],
  )
  const Screen = resolveScreen(screenName)

  useEffect(() => {
    document.title = screenTitle(screenName)
  }, [screenName])

  if (!Screen) {
    return (
      <main style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
        <h1>Tela ACUL não implementada</h1>
        <p>
          Screen: <code>{screenName}</code>
        </p>
        <p>
          Em produção isto roda em <code>https://acesso-b2c-dev.siteteste.inf.br</code> via
          Universal Login. Em local use{' '}
          <code>?screen=login-password</code>.
        </p>
      </main>
    )
  }

  return (
    <Suspense fallback={<div style={{ padding: '2rem' }}>Carregando…</div>}>
      <Screen />
    </Suspense>
  )
}

createRoot(ensureRootElement()).render(<App />)
